export default __webpack_public_path__ + "gravity-affixfeea9b.gif";